import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@/hooks/useQuery'
import { Tab } from '@headlessui/react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Tabs({ items, routing = true, navWrapperClass = '', rowCount = false, onRowChange }) {
  const router = useNavigate()
  const query = useQuery()
  const [defaultIndex, setDefaultIndex] = useState(0)
  useEffect(() => {
    if (!routing) return null
    const tab = query.get('tab')
    if (tab) setDefaultIndex(items.indexOf(items.find(item => item.key == tab)))
  }, [query])

  return (
    <Tab.Group defaultIndex={defaultIndex} onChange={(index) => {
      if (!routing) return null
      query.set('tab', items[index].key)
      router({ search: query.toString() })
    }}>
      <div className={navWrapperClass || 'flex justify-center'}>
        <Tab.List className="inline-flex border-b border-gray-700 space-x-8 w-full -mb-1">
          {Object.values(items).map((item) => (
            <Tab
              key={item.title}
              className={({ selected }) =>
                classNames(
                  'pt-4 pb-4 text-sm leading-5 font-medium',
                  'focus:outline-none',
                  selected
                    ? 'text-white border-b-2 border-purple-600'
                    : 'text-gray-300 hover:text-gray-200 border-b-2 border-transparent'
                )
              }
            >
              <span className="block">{item.title}</span>
            </Tab>
          ))}
        </Tab.List>
      </div>
      <Tab.Panels className="mt-2">
        {Object.values(items).map((item, idx) => (
          <Tab.Panel
            key={idx}>
            {item.panel}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  )
}
